import React, {PureComponent} from 'react'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {fetchCoursesIfNeeded} from '../../actions/courses'
import {fetchAndUpdatePreferredCourse, fetchRequiredCourse} from '../../actions/course'

const mapStateToProps = ({courses: { data }, course: { selectedCourseCode, selectedCourse }}) => {
  return {
    courseCode: selectedCourseCode,
    courseTitle: selectedCourse.courseTitle,
    offers: Object.keys(data).filter(courseCode => courseCode !== selectedCourseCode).map(courseCode => {
      return data[courseCode]
    })
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCourses: () => {
      dispatch(fetchCoursesIfNeeded())
    },
    fetchRequiredCourse: (offers) => {
      dispatch(fetchRequiredCourse(offers))
    },
    switchPreferredCourse: course => {
      dispatch(fetchAndUpdatePreferredCourse(course))
    },
  }
}

export class CourseSelect extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      enrolmentSelectOpen: false,
    }
  }

  componentDidMount() {
    this.props.fetchCourses()
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log("CS CDU props", this.props)

  //   if (prevProps.courseCode !== this.props.courseCode) {
  //     this.props.fetchRequiredCourse(this.props.courseSummary)
  //   }
  // }

  getButtonClass() {
    let courseClass = ['btn-change-course']

    if (this.state.enrolmentSelectOpen) {
      courseClass.push('isActive')
    }

    return courseClass.join(' ')
  }

  updateUnit = course => {
    return () => {
      this.toggleCourseListButton()
      this.props.switchPreferredCourse(course)
    }
  }

  toggleCourseListButton = () => {
    this.setState({
      enrolmentSelectOpen: !this.state.enrolmentSelectOpen,
    })
  }

  render() {
    return (
      <div className={(this.state.enrolmentSelectOpen) ? 'slidein__course isActive' : 'slidein__course'}>
        <h2 className='slidein__course-title'>{this.props.courseTitle} [{this.props.courseCode}]</h2>
        {this.props.offers.length > 0 ? (
          <div>
            <button className={this.getButtonClass()} onClick={this.toggleCourseListButton}>Change course</button>
            <ul className={(this.state.enrolmentSelectOpen) ? 'slidein__course-dropdown isActive' : 'slidein__course-dropdown'}>
              {this.props.offers.map(item => {
                return <li key={item.courseCode}><button className='dropdown-item' onClick={this.updateUnit(item)}>{item.courseTitle} [{item.courseCode}]</button></li>
              })}
            </ul>
          </div>
        ) : null}

      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseSelect))
